import { render } from "./CookCardComponent.vue?vue&type=template&id=e0f35f18&scoped=true"
import script from "./CookCardComponent.vue?vue&type=script&lang=js"
export * from "./CookCardComponent.vue?vue&type=script&lang=js"

import "./CookCardComponent.vue?vue&type=style&index=0&id=e0f35f18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0f35f18"]])

export default __exports__